import MuiButton from '@mui/material/Button'
import { MouseEvent } from 'react'
import styles from './Button.module.scss'
// eslint-disable-next-line import/no-cycle
import { getButtonStyles } from './Button.styles'

export interface ButtonProps {
  onClick?: (event?: MouseEvent<HTMLElement>) => void
  label: string | JSX.Element
  variant: 'text' | 'outlined' | 'contained'
  color: 'primary' | 'secondary'
  mobile?: boolean
  textAlignment?: 'left' | 'center' | 'right'
  icon?: string | JSX.Element
  underline?: boolean
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  maxWidth?: boolean
  form?: string
  smallFont?: boolean
  secondaryButton?: boolean
  condensedLabel?: boolean
  iconPosition?: 'start' | 'end'
  additionalIcon?: string | JSX.Element
  /** Accessible name, needed when the visible label is empty (icon-only). */
  ariaLabel?: string
}

function Button(props: ButtonProps) {
  const {
    onClick,
    label,
    type,
    disabled,
    variant,
    color,
    mobile,
    textAlignment,
    icon,
    underline,
    maxWidth,
    form,
    smallFont,
    secondaryButton,
    condensedLabel,
    iconPosition = 'start',
    additionalIcon,
    ariaLabel
  } = props

  const buttonStyles = getButtonStyles(color, variant, secondaryButton)

  return (
    <MuiButton
      className={`${styles.buttonComponent} ${
        mobile ? styles.buttonMobile : ''
      }`}
      onClick={onClick}
      disabled={disabled}
      type={type || 'button'}
      variant={variant}
      color={color}
      aria-label={
        ariaLabel ?? (typeof label === 'string' ? label : undefined)
      }
      sx={{
        ...buttonStyles,
        justifyContent: textAlignment || 'center',
        textDecoration: underline ? 'underline' : 'none',
        width: maxWidth ? '100%' : 'fit-content',
        minWidth: 'fit-content'
      }}
      disableRipple
      form={form}
    >
      {icon &&
        iconPosition === 'start' &&
        (typeof icon === 'string' ? (
          <i className={`${icon} icon-big`} />
        ) : (
          icon
        ))}
      {typeof label === 'string' && (
        <p
          className={`${styles.buttonLabel} ${
            smallFont ? 'body-bold-small' : 'body-bold-medium'
          } ${condensedLabel ? styles.buttonLabelCondensed : ''}`}
        >
          {label}
        </p>
      )}
      {typeof label !== 'string' && label}
      {icon &&
        iconPosition === 'end' &&
        (typeof icon === 'string' ? (
          <i className={`${icon} icon-big`} />
        ) : (
          icon
        ))}
      {additionalIcon &&
        (typeof additionalIcon === 'string' ? (
          <i className={`${additionalIcon} icon-big`} />
        ) : (
          additionalIcon
        ))}
    </MuiButton>
  )
}

export default Button
